<template>
    <div class="w-100 user-chat">
      <b-button @click="addTasks">Debug tasks</b-button>
        <div class=""> <!-- card -->
          <div class="chat-users">
            <div class="chat-conversation p-2">
              <simplebar
                style="max-height: 470px"
                id="containerElement"
                ref="current"
              >
                <ul class="list-unstyled">
                  <li
                    v-for="data of chat_data"
                    :key="data.message"
                    :class="{ right: `${data.align}` === 'right' }"
                  >
                    <div style="max-width: 75%;" class="conversation-list">
                      <b-dropdown
                        variant="white"
                        menu-class="dropdown-menu-end"
                      >
                        <template v-slot:button-content>
                          <!--<i class="bx bx-dots-vertical-rounded"></i>-->
                          <i v-if="data.align != 'right' && data.hasRead == 'Read'" class="fas fa-thumbs-up" style="color: limegreen;"></i>
                          <i v-else-if="data.align != 'right' && data.hasRead == 'Unread'" class="fas fa-thumbs-down" style="color: red;"></i>
                          <i v-if="data.align === 'right'" class="bx bx-dots-vertical-rounded"></i>
                        </template>
                        <!--<b-dropdown-item v-if="data.align != 'right'" @click="readComment(data.id)">Mark as read</b-dropdown-item>
                        <b-dropdown-item v-if="data.align === 'right'" @click="deleteAdminComment(data.id)">Delete</b-dropdown-item>-->
                        <b-dropdown-item v-if="data.align != 'right' && data.hasRead === 'Unread'" @click="readComment(data.id)">Mark as read</b-dropdown-item>
                        <b-dropdown-item v-if="data.align === 'right'" @click="deleteAdminComment(data.id)">Delete</b-dropdown-item>
                        <b-dropdown-item v-if="data.align != 'right' && data.hasRead == 'Read'" disabled>No Action Avaliable</b-dropdown-item>
                      </b-dropdown>
                      <div class="ctext-wrap">
                        <div class="conversation-name">{{ data.user_name }}</div>
                        <p>{{ data.body }}</p>
                        <p class="chat-time mb-0">
                          <i class="bx bx-time-five align-middle me-1 mb-1"></i>
                          {{ parseDate(data.created_at) }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </simplebar>
            </div>
            <div class="p-2 chat-input-section">
              <form @submit.prevent="formSubmit" class="row">
                <div class="col">
                  <div class="position-relative">
                    <input
                      type="text"
                      v-model="form.message"
                      class="form-control chat-input rounded"
                      placeholder="Enter Message..."
                      :class="{
                        'is-invalid': submitted && $v.form.message.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.message.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.message.required"
                        >This value is required.</span
                      >
                    </div>
                    <div class="chat-input-links">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                          <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            title="Add Link"
                          >
                            <i class="mdi mdi-link-variant"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <button
                    type="submit"
                    class="btn btn-primary btn-rounded chat-send w-md"
                  >
                    <span class="d-none d-sm-inline-block me-2">Send</span>
                    <i class="mdi mdi-send"></i>
                  </button>
                </div>
              </form>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import { parseISO, format} from 'date-fns';
import { ccbAdminState, ccbAdminMethods } from '@/state/helpers'
import _ from 'lodash';
import simplebar from "simplebar-vue";
import { required } from "vuelidate/lib/validators";
export default {
    components:{
        simplebar,
    },
    validations: {
        form: {
            message: {
                required,
            },
        },
    },
    data:() => ({
        submitted: false,
        form: {
            message: "",
        },

        //chat_data: []
    }),
    computed:{
      ...ccbAdminState,
      chat_data(){
        let comments = _.cloneDeep(this.client_step_data.comments);
        comments.forEach((comment) => {
          //*Add date key
          comment['date'] = new Date(comment.created_at)
          comment['hasRead'] = ''
          if(comment.type == 'admin_comment'){
            comment['align'] = 'right';
          }
          else{
            if(comment.tracking.read_user_id != undefined){
              if(comment.tracking.read_user_id == this.core_data.id){
                comment['hasRead'] = 'Read'
              }
              else{
                comment['hasRead'] = 'Unread'
              }
            }
            else{
              comment['hasRead'] = 'Unread'
            }
          }
        });

        comments = _.sortBy(comments, ['date']);
        return comments;
      }
    },
    methods:{
      ...ccbAdminMethods,
      parseDate(raw_date){
        let date = format(parseISO(raw_date), 'dd MMM yyyy');
        let time = format(parseISO(raw_date), 'HH:mm a');
        return date + ' - ' + time;
      },
      addTasks(){
            let p1 = {
                client_id: this.client_data.client.id,
                step_id: this.client_step_data.id,
                step_validation_id: null,
                type: 'user_task',
                due_date: null,
                task_user_id: null,
                body: 'Task user'
            }

            let p2 = {
                client_id: this.client_data.client.id,
                step_id: this.client_step_data.id,
                step_validation_id: null,
                type: 'admin_task',
                due_date: null,
                task_user_id: null,
                body: 'Task admin'
            }
            
            this.addUserTask(p1);
            this.addAdminTask(p2);
        },
      update(){
        let step_params = {
          client_id: this.client_data.client.id,
          step_id: this.client_step_data.id,
        }
        this.loadClientStepData(step_params)
        .then(()=>{
          this.handleScroll();
        })
      },
        // eslint-disable-next-line no-unused-vars
        formSubmit(e) {
            this.submitted = true;

            // stop here if form is invalid
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            } else {
                let params = {
                  client_id: this.client_data.client.id,
                  step_id: this.client_step_data.id,
                  body: this.form.message,
                  step_validation: '',
                  due_date: '',
                  task_user_id: '',
                  type: 'admin_comment',
                }
                this.addComment(params)
                .then(()=>{
                  this.update();
                })
                .catch(()=>{
                  console.log('Add comment error')
                })
                this.handleScroll();
            }
            this.submitted = false;
            this.form = {};
        },
        handleScroll() {
            if (this.$refs.current.$el) {
                setTimeout(() => {
                    this.$refs.current.SimpleBar.getScrollElement().scrollTop =
                    this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
                }, 500);
            }
        },
        readComment(id){
          let params = {
            client_step_action_id: id,
          }
          this.markAsRead(params)
          .then(()=>{
            this.update();
          })
            
        },
        deleteAdminComment(id){
          this.deleteStepAction({id:id})
          .then(()=>{
            this.update();
          })
        }
    },
    mounted(){
        var container2 = document.querySelector(
            "#containerElement .simplebar-content-wrapper"
        );
        container2.scrollTo({ top: 500, behavior: "smooth" });
    },
}
</script>

<style>
.chat-conversation .right .conversation-list .ctext-wrap{
  background-color: #dffff3 !important;
}
</style>